// import React from 'react';
// import {
//   Table,
//   Button,
//   ActionIcon,
//   Group,
//   Text,
//   Paper,
//   Box,
//   Stack,
//   Divider,
//   Flex,
// } from '@mantine/core';
// import {
//   IconTrash,
//   IconCheck,
//   IconX,
//   IconCalendar,
//   IconUser,
//   IconSchool,
//   IconFileText,
//   IconUpload,
//   IconEye,
// } from '@tabler/icons-react';
// import { Batch } from '../types/batch.types';
// import { Pencil } from 'lucide-react';
// import { useMediaQuery } from '@mantine/hooks';
// import AdminResourceActions from "./AdminResourceActions";

// interface BatchTableProps {
//   batches: Batch[];
//   onBatchClick: (batch: Batch) => void;
//   onDeleteClick: (batch: Batch) => void;
//   onStatusChange: (batchNo: string, status: string) => void;
//   onMouStatusChange: (batchNo: string, status: string) => void;
//   onSessionEdit: (batchNo: string, currentValue: number) => void;
//   editingSessionId: string | null;
//   sessionInputValue: number;
//   onSessionSave: (batchNo: string) => void;
//   onSessionCancel: () => void;
//   onSessionValueChange: (value: number) => void;
//   compact?: boolean;

//   /**  NEW – Resource handlers */
//   onUploadResource: (batchNo: string) => void;
//   onViewResource: (batchNo: string) => void;
// }

// export const BatchTable: React.FC<BatchTableProps> = ({
//   batches,
//   onBatchClick,
//   onDeleteClick,
//   onStatusChange,
//   onMouStatusChange,
//   onSessionEdit,
//   editingSessionId,
//   sessionInputValue,
//   onSessionSave,
//   onSessionCancel,
//   onSessionValueChange,
//   onUploadResource,
//   onViewResource,
//   compact = false,
// }) => {
//   const isMobile = useMediaQuery('(max-width: 768px)');

//   const getStatusColor = (status: string) => {
//     switch (status) {
//       case 'Completed': return '#28a745';
//       case 'Hold': return '#ffc107';
//       case 'On-going': return '#007bff';
//       case 'Not Started': return '#6c757d';
//       case 'Absconded': return '#dc3545';
//       case 'Discarded': return '#343a40';
//       default: return '#6c757d';
//     }
//   };

//   const getMouStatusColor = (status: string) => {
//     switch (status) {
//       case 'Signed': return '#28a745';
//       case 'Sent': return '#ffc107';
//       case 'Not Sent': return '#dc3545';
//       case 'Expired': return '#6c757d';
//       default: return '#007bff';
//     }
//   };

//   /* ===========================
//      MOBILE CARD VIEW
//   ============================ */
//   const MobileCardView = ({ batch }: { batch: Batch }) => (
//     <Paper shadow="md" radius="md" withBorder p="sm" mb="sm">
//       <Stack gap="xs">
//         <Group justify="space-between">
//           <Button size="xs" onClick={() => onBatchClick(batch)}>
//             #{batch.batch_no}
//           </Button>
//           <ActionIcon color="red" onClick={() => onDeleteClick(batch)}>
//             <IconTrash size={16} />
//           </ActionIcon>
//         </Group>

//         <Text size="sm" fw={600}>{batch.courseName || 'N/A'}</Text>

//         <Divider />

//         {/*  Resources section */}
//         <Group justify="space-between">
//           <Text size="xs" fw={600}>Resources</Text>
//           <Group gap="xs">
//             <Button
//               size="xs"
//               leftSection={<IconUpload size={14} />}
//               onClick={() => onUploadResource(batch.batch_no)}
//             >
//               Upload
//             </Button>
//             <Button
//               size="xs"
//               variant="subtle"
//               leftSection={<IconEye size={14} />}
//               onClick={() => onViewResource(batch.batch_no)}
//             >
//               View
//             </Button>
//           </Group>
//         </Group>
//       </Stack>
//     </Paper>
//   );

//   if (isMobile) {
//     return (
//       <Box p="xs">
//         {batches.map((batch) => (
//           <MobileCardView key={batch.batch_no} batch={batch} />
//         ))}
//       </Box>
//     );
//   }

//   /* ===========================
//      DESKTOP TABLE VIEW
//   ============================ */
//   return (
//     <Box style={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
//       <Table striped highlightOnHover>
//         <Table.Thead>
//           <Table.Tr>
//             <Table.Th>Batch No</Table.Th>
//             <Table.Th>Start Date</Table.Th>
//             {/* <Table.Th>MOU Status</Table.Th> */}
//             <Table.Th>Course</Table.Th>
//             <Table.Th>Trainer</Table.Th>
//             <Table.Th>Sessions</Table.Th>
//             <Table.Th>Admin</Table.Th>
//             <Table.Th>Status</Table.Th>
//             <Table.Th>Resources</Table.Th>
//             <Table.Th>Actions</Table.Th>
//           </Table.Tr>
//         </Table.Thead>

//         <Table.Tbody>
//           {batches.map((batch) => (
//             <Table.Tr key={batch.batch_no}>
//               <Table.Td>
//                 <Button size="xs" onClick={() => onBatchClick(batch)}>
//                   {batch.batch_no}
//                 </Button>
//               </Table.Td>

//               <Table.Td>
//                 {batch.startDate
//                   ? new Date(batch.startDate).toLocaleDateString('en-GB')
//                   : 'N/A'}
//               </Table.Td>

//             {/* <Table.Td>
//                <select
//                 value={batch.MouStatus || ""}
//                onChange={(e) => onMouStatusChange(batch.batch_no, e.target.value)}
//                style={{
//                    padding: compact ? "4px" : "5px",
//                    fontSize: compact ? "10px" : "11px",
//                    borderRadius: "5px",
//                    width: compact ? "110px" : "130px",
//                    textAlign: "center",
//                   backgroundColor: getMouStatusColor(batch.MouStatus || ""),
//                  color: "white",
//                   fontWeight: "bold",
//                   border: "1px solid #ccc",
//                  cursor: "pointer",
//                }}
//                >
//                 <option value="Signed">Signed</option>
//                  <option value="Sent">Sent</option>
//                  <option value="Not Sent">Not Sent</option>
//                  <option value="Expired">Expired</option>
//                </select>
//             </Table.Td> */}

//               <Table.Td>{batch.courseName || 'N/A'}</Table.Td>
//               <Table.Td>{batch.trainerName || 'N/A'}</Table.Td>

//               <Table.Td>
//                 {editingSessionId === batch.batch_no ? (
//                   <Group gap="xs">
//                     <input
//                       type="number"
//                       value={sessionInputValue}
//                       onChange={(e) =>
//                         onSessionValueChange(parseInt(e.target.value))
//                       }
//                     />
//                     <ActionIcon color="green" onClick={() => onSessionSave(batch.batch_no)}>
//                       <IconCheck size={16} />
//                     </ActionIcon>
//                     <ActionIcon color="gray" onClick={onSessionCancel}>
//                       <IconX size={16} />
//                     </ActionIcon>
//                   </Group>
//                 ) : (
//                   <Group gap="xs">
//                     <Text>{batch.numSessions || 0}</Text>
//                     <ActionIcon
//                       variant="light"
//                       onClick={() =>
//                         onSessionEdit(batch.batch_no, batch.numSessions ?? 0)
//                       }
//                     >
//                       <Pencil size={16} />
//                     </ActionIcon>
//                   </Group>
//                 )}
//               </Table.Td>

//               <Table.Td>{batch.admin || 'N/A'}</Table.Td>
//  <Table.Td>
//               <select
//                 value={batch.batchStatus}
//                 onChange={(e) => onStatusChange(batch.batch_no, e.target.value)}
//                 style={{
//                   padding: compact ? "4px" : "5px",
//                   fontSize: compact ? "10px" : "11px",
//                   borderRadius: "5px",
//                   width: compact ? "110px" : "130px",
//                   textAlign: "center",
//                   backgroundColor: getStatusColor(batch.batchStatus || "Not Started"),
//                   color: "white",
//                   fontWeight: "bold",
//                   border: "1px solid #ccc",
//                   cursor: "pointer",
//                 }}
//               >
//                 <option value="Completed">Completed</option>
//                 <option value="Hold">Hold</option>
//                 <option value="On-going">On-going</option>
//                 <option value="Not Started">Not Started</option>
//                 <option value="Absconded">Absconded</option>
//                 <option value="Discarded">Discarded</option>
//               </select>
//             </Table.Td>

//               {/*  Resources column */}
//               {/* <Table.Td>
//                 <Group gap="xs">
//                   <Button
//                     size="xs"
//                     leftSection={<IconUpload size={14} />}
//                     onClick={() => onUploadResource(batch.batch_no)}
//                   >
//                     Upload
//                   </Button>
//                   <Button
//                     size="xs"
//                     variant="subtle"
//                     leftSection={<IconEye size={14} />}
//                     onClick={() => onViewResource(batch.batch_no)}
//                   >
//                     View
//                   </Button>
//                 </Group>
//               </Table.Td> */}
// <Table.Td>
//   <AdminResourceActions
//     batchNo={batch.batch_no}
//     onUpload={() => onUploadResource(batch.batch_no)}
//     onView={() => onViewResource(batch.batch_no)}
//   />
// </Table.Td>

//              <ActionIcon
//   color="red"
//   variant="light"
//   onClick={() => onDeleteClick(batch)}
// >
//   <IconTrash size={16} />
// </ActionIcon>

//             </Table.Tr>
//           ))}
//         </Table.Tbody>
//       </Table>
//     </Box>
//   );
// };

// import React from 'react';
// import {
//   Table,
//   Button,
//   ActionIcon,
//   Group,
//   Text,
//   Paper,
//   Box,
//   Stack,
//   Divider,
//   Flex,
// } from '@mantine/core';
// import {
//   IconTrash,
//   IconCheck,
//   IconX,
//   IconCalendar,
//   IconUser,
//   IconSchool,
//   IconFileText,
//   IconUpload,
//   IconEye,
// } from '@tabler/icons-react';
// import { Batch } from '../types/batch.types';
// import { Pencil } from 'lucide-react';
// import { useMediaQuery } from '@mantine/hooks';
// import AdminResourceActions from "./AdminResourceActions";

// interface BatchTableProps {
//   batches: Batch[];
//   onBatchClick: (batch: Batch) => void;
//   onDeleteClick: (batch: Batch) => void;
//   onStatusChange: (batchNo: string, status: string) => void;
//   onMouStatusChange: (batchNo: string, status: string) => void;
//   onSessionEdit: (batchNo: string, currentValue: number) => void;
//   editingSessionId: string | null;
//   sessionInputValue: number;
//   onSessionSave: (batchNo: string) => void;
//   onSessionCancel: () => void;
//   onSessionValueChange: (value: number) => void;
//   compact?: boolean;

//   /**  NEW – Resource handlers */
//   onUploadResource: (batchNo: string) => void;
//   onViewResource: (batchNo: string) => void;
// }

// export const BatchTable: React.FC<BatchTableProps> = ({
//   batches,
//   onBatchClick,
//   onDeleteClick,
//   onStatusChange,
//   onMouStatusChange,
//   onSessionEdit,
//   editingSessionId,
//   sessionInputValue,
//   onSessionSave,
//   onSessionCancel,
//   onSessionValueChange,
//   onUploadResource,
//   onViewResource,
//   compact = false,
// }) => {
//   const isMobile = useMediaQuery('(max-width: 768px)');

//   const getStatusColor = (status: string) => {
//     switch (status) {
//       case 'Completed': return '#28a745';
//       case 'Hold': return '#ffc107';
//       case 'On-going': return '#007bff';
//       case 'Not Started': return '#6c757d';
//       case 'Absconded': return '#dc3545';
//       case 'Discarded': return '#343a40';
//       default: return '#6c757d';
//     }
//   };

//   const getMouStatusColor = (status: string) => {
//     switch (status) {
//       case 'Signed': return '#28a745';
//       case 'Sent': return '#ffc107';
//       case 'Not Sent': return '#dc3545';
//       case 'Expired': return '#6c757d';
//       default: return '#007bff';
//     }
//   };

//   /* ===========================
//      MOBILE CARD VIEW
//   ============================ */
//   const MobileCardView = ({ batch }: { batch: Batch }) => (
//     <Paper shadow="md" radius="md" withBorder p="sm" mb="sm">
//       <Stack gap="xs">
//         <Group justify="space-between">
//           <Button size="xs" onClick={() => onBatchClick(batch)}>
//             #{batch.batch_no}
//           </Button>
//           <ActionIcon color="red" onClick={() => onDeleteClick(batch)}>
//             <IconTrash size={16} />
//           </ActionIcon>
//         </Group>

//         <Text size="sm" fw={600}>{batch.courseName || 'N/A'}</Text>

//         <Divider />

//         {/*  Resources section */}
//         <Group justify="space-between">
//           <Text size="xs" fw={600}>Resources</Text>
//           <Group gap="xs">
//             <Button
//               size="xs"
//               leftSection={<IconUpload size={14} />}
//               onClick={() => onUploadResource(batch.batch_no)}
//             >
//               Upload
//             </Button>
//             <Button
//               size="xs"
//               variant="subtle"
//               leftSection={<IconEye size={14} />}
//               onClick={() => onViewResource(batch.batch_no)}
//             >
//               View
//             </Button>
//           </Group>
//         </Group>
//       </Stack>
//     </Paper>
//   );

//   if (isMobile) {
//     return (
//       <Box p="xs">
//         {batches.map((batch) => (
//           <MobileCardView key={batch.batch_no} batch={batch} />
//         ))}
//       </Box>
//     );
//   }

//   /* ===========================
//      DESKTOP TABLE VIEW
//   ============================ */
//   return (
//     <Box style={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
//       <Table striped highlightOnHover>
//         <Table.Thead>
//           <Table.Tr>
//             <Table.Th>Batch No</Table.Th>
//             <Table.Th>Start Date</Table.Th>
//             {/* <Table.Th>MOU Status</Table.Th> */}
//             <Table.Th>Course</Table.Th>
//             <Table.Th>Trainer</Table.Th>
//             <Table.Th>Sessions</Table.Th>
//             <Table.Th>Admin</Table.Th>
//             <Table.Th>Status</Table.Th>
//             <Table.Th>Resources</Table.Th>
//             <Table.Th>Actions</Table.Th>
//           </Table.Tr>
//         </Table.Thead>

//         <Table.Tbody>
//           {batches.map((batch) => (
//             <Table.Tr key={batch.batch_no}>
//               <Table.Td>
//                 <Button size="xs" onClick={() => onBatchClick(batch)}>
//                   {batch.batch_no}
//                 </Button>
//               </Table.Td>

//               <Table.Td>
//                 {batch.startDate
//                   ? new Date(batch.startDate).toLocaleDateString('en-GB')
//                   : 'N/A'}
//               </Table.Td>

//             {/* <Table.Td>
//                <select
//                 value={batch.MouStatus || ""}
//                onChange={(e) => onMouStatusChange(batch.batch_no, e.target.value)}
//                style={{
//                    padding: compact ? "4px" : "5px",
//                    fontSize: compact ? "10px" : "11px",
//                    borderRadius: "5px",
//                    width: compact ? "110px" : "130px",
//                    textAlign: "center",
//                   backgroundColor: getMouStatusColor(batch.MouStatus || ""),
//                  color: "white",
//                   fontWeight: "bold",
//                   border: "1px solid #ccc",
//                  cursor: "pointer",
//                }}
//                >
//                 <option value="Signed">Signed</option>
//                  <option value="Sent">Sent</option>
//                  <option value="Not Sent">Not Sent</option>
//                  <option value="Expired">Expired</option>
//                </select>
//             </Table.Td> */}

//               <Table.Td>{batch.courseName || 'N/A'}</Table.Td>
//               <Table.Td>{batch.trainerName || 'N/A'}</Table.Td>

//               <Table.Td>
//                 {editingSessionId === batch.batch_no ? (
//                   <Group gap="xs">
//                     <input
//                       type="number"
//                       value={sessionInputValue}
//                       onChange={(e) =>
//                         onSessionValueChange(parseInt(e.target.value))
//                       }
//                     />
//                     <ActionIcon color="green" onClick={() => onSessionSave(batch.batch_no)}>
//                       <IconCheck size={16} />
//                     </ActionIcon>
//                     <ActionIcon color="gray" onClick={onSessionCancel}>
//                       <IconX size={16} />
//                     </ActionIcon>
//                   </Group>
//                 ) : (
//                   <Group gap="xs">
//                     <Text>{batch.numSessions || 0}</Text>
//                     <ActionIcon
//                       variant="light"
//                       onClick={() =>
//                         onSessionEdit(batch.batch_no, batch.numSessions ?? 0)
//                       }
//                     >
//                       <Pencil size={16} />
//                     </ActionIcon>
//                   </Group>
//                 )}
//               </Table.Td>

//               <Table.Td>{batch.admin || 'N/A'}</Table.Td>
//  <Table.Td>
//               <select
//                 value={batch.batchStatus}
//                 onChange={(e) => onStatusChange(batch.batch_no, e.target.value)}
//                 style={{
//                   padding: compact ? "4px" : "5px",
//                   fontSize: compact ? "10px" : "11px",
//                   borderRadius: "5px",
//                   width: compact ? "110px" : "130px",
//                   textAlign: "center",
//                   backgroundColor: getStatusColor(batch.batchStatus || "Not Started"),
//                   color: "white",
//                   fontWeight: "bold",
//                   border: "1px solid #ccc",
//                   cursor: "pointer",
//                 }}
//               >
//                 <option value="Completed">Completed</option>
//                 <option value="Hold">Hold</option>
//                 <option value="On-going">On-going</option>
//                 <option value="Not Started">Not Started</option>
//                 <option value="Absconded">Absconded</option>
//                 <option value="Discarded">Discarded</option>
//               </select>
//             </Table.Td>

//               {/*  Resources column */}
//               {/* <Table.Td>
//                 <Group gap="xs">
//                   <Button
//                     size="xs"
//                     leftSection={<IconUpload size={14} />}
//                     onClick={() => onUploadResource(batch.batch_no)}
//                   >
//                     Upload
//                   </Button>
//                   <Button
//                     size="xs"
//                     variant="subtle"
//                     leftSection={<IconEye size={14} />}
//                     onClick={() => onViewResource(batch.batch_no)}
//                   >
//                     View
//                   </Button>
//                 </Group>
//               </Table.Td> */}
// <Table.Td>
//   <AdminResourceActions
//     batchNo={batch.batch_no}
//     onUpload={() => onUploadResource(batch.batch_no)}
//     onView={() => onViewResource(batch.batch_no)}
//   />
// </Table.Td>

//              <ActionIcon
//   color="red"
//   variant="light"
//   onClick={() => onDeleteClick(batch)}
// >
//   <IconTrash size={16} />
// </ActionIcon>

//             </Table.Tr>
//           ))}
//         </Table.Tbody>
//       </Table>
//     </Box>
//   );
// };

import React, { useState } from "react";
import {
  Table,
  Button,
  ActionIcon,
  Group,
  Text,
  Paper,
  Box,
  Stack,
  Divider,
  Tooltip,
  Modal,
  Textarea,
} from "@mantine/core";
import {
  IconTrash,
  IconCheck,
  IconX,
  IconUpload,
  IconEye,
  IconTimeline, //  NEW
  IconHistory, //  NEW
  IconVideo,
  IconVideoOff,
  IconExternalLink,
} from "@tabler/icons-react";
import { Batch } from "../types/batch.types";
import { Pencil } from "lucide-react";
import { useMediaQuery } from "@mantine/hooks";
import { useNavigate } from "react-router-dom"; //  NEW
import AdminResourceActions from "./AdminResourceActions";
import AttendedHoursLogsModal from "./AttendedHoursLogsModal"; //  NEW

const STATUSES_REQUIRING_COMMENT = ["Hold", "Discarded", "Absconded"];

interface BatchTableProps {
  batches: Batch[];
  onBatchClick: (batch: Batch) => void;
  onDeleteClick: (batch: Batch) => void;
  onStatusChange: (batchNo: string, status: string, statusComment?: string) => void;
  onMouStatusChange: (batchNo: string, status: string) => void;
  onSessionEdit: (batchNo: string, currentValue: number) => void;
  editingSessionId: string | null;
  sessionInputValue: number;
  onSessionSave: (batchNo: string) => void;
  onSessionCancel: () => void;
  onSessionValueChange: (value: number) => void;
  compact?: boolean;
  onUploadResource: (batchNo: string) => void;
  onViewResource: (batchNo: string) => void;
  // onViewJourney: (batchNo: string) => void;
}

export const BatchTable: React.FC<BatchTableProps> = ({
  batches,
  onBatchClick,
  onDeleteClick,
  onStatusChange,
  onSessionEdit,
  editingSessionId,
  sessionInputValue,
  onSessionSave,
  onSessionCancel,
  onSessionValueChange,
  onUploadResource,
  onViewResource,
  // onViewJourney,
  compact = false,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate(); //  NEW
  const [logsBatchNo, setLogsBatchNo] = useState<string | null>(null); //  NEW
  // Hold / Discarded / Absconded need a reason before the status is saved
  const [pendingStatus, setPendingStatus] = useState<{ batchNo: string; status: string } | null>(null);
  const [statusComment, setStatusComment] = useState("");

  const handleStatusSelect = (batch: Batch, status: string) => {
    if (STATUSES_REQUIRING_COMMENT.includes(status)) {
      setStatusComment(batch.batchStatus === status ? batch.statusComment || "" : "");
      setPendingStatus({ batchNo: batch.batch_no, status });
      return;
    }
    onStatusChange(batch.batch_no, status);
  };

  const closeStatusModal = () => {
    setPendingStatus(null);
    setStatusComment("");
  };

  const confirmStatus = () => {
    if (!pendingStatus || !statusComment.trim()) return;
    onStatusChange(pendingStatus.batchNo, pendingStatus.status, statusComment.trim());
    closeStatusModal();
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Completed":
        return "#28a745";
      case "Hold":
        return "#ffc107";
      case "On-going":
        return "#007bff";
      case "Not Started":
        return "#6c757d";
      case "Absconded":
        return "#dc3545";
      case "Discarded":
        return "#343a40";
      default:
        return "#6c757d";
    }
  };

  /* ===========================
     MEETING LINK STATUS
  ============================ */
  const MeetingStatusBadge = ({ batch }: { batch: Batch }) => {
    const hasMeetingLink = Boolean(batch.meetingLink?.trim());

    return (
      <Group gap={4} wrap="nowrap">
        <Tooltip label={hasMeetingLink ? "Meeting link added" : "No meeting link"}>
          <ActionIcon
            size={compact ? "sm" : "md"}
            variant="light"
            color={hasMeetingLink ? "green" : "gray"}
            style={{ cursor: "default" }}
          >
            {hasMeetingLink ? (
              <IconVideo size={16} />
            ) : (
              <IconVideoOff size={16} />
            )}
          </ActionIcon>
        </Tooltip>

        {hasMeetingLink && (
          <Tooltip label="Open meeting link">
            <ActionIcon
              size={compact ? "sm" : "md"}
              variant="light"
              color="blue"
              component="a"
              href={batch.meetingLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconExternalLink size={16} />
            </ActionIcon>
          </Tooltip>
        )}
      </Group>
    );
  };

  /* ===========================
     MOBILE CARD VIEW
  ============================ */
  const MobileCardView = ({ batch }: { batch: Batch }) => (
    <Paper shadow="md" radius="md" withBorder p="sm" mb="sm">
      <Stack gap="xs">
        <Group justify="space-between">
          <Button size="xs" onClick={() => onBatchClick(batch)}>
            #{batch.batch_no}
          </Button>
          <ActionIcon color="red" onClick={() => onDeleteClick(batch)}>
            <IconTrash size={16} />
          </ActionIcon>
        </Group>

        <Text size="sm" fw={600}>
          {batch.courseName || "N/A"}
        </Text>

        <Group justify="space-between">
          <Text size="xs" fw={600}>
            Meeting
          </Text>
          <MeetingStatusBadge batch={batch} />
        </Group>

        <Divider />

        <Group justify="space-between">
          <Text size="xs" fw={600}>
            Resources
          </Text>
          <Group gap="xs">
            <Button
              size="xs"
              leftSection={<IconUpload size={14} />}
              onClick={() => onUploadResource(batch.batch_no)}
            >
              Upload
            </Button>
            <Button
              size="xs"
              variant="subtle"
              leftSection={<IconEye size={14} />}
              onClick={() => onViewResource(batch.batch_no)}
            >
              View
            </Button>
          </Group>
        </Group>
      </Stack>
    </Paper>
  );

  const logsModal = (
    <>
      <AttendedHoursLogsModal
        isOpen={!!logsBatchNo}
        batchNo={logsBatchNo}
        onClose={() => setLogsBatchNo(null)}
      />
      <Modal
        opened={!!pendingStatus}
        onClose={closeStatusModal}
        title={<Text fw={600}>{`Set #${pendingStatus?.batchNo} to ${pendingStatus?.status}`}</Text>}
        centered
      >
        <Textarea
          label="Comment"
          description="Required. This is shown as a tooltip on the status."
          placeholder="Why is this batch being moved to this status?"
          value={statusComment}
          onChange={(e) => setStatusComment(e.currentTarget.value)}
          minRows={3}
          autosize
          data-autofocus
          withAsterisk
        />
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={closeStatusModal}>Cancel</Button>
          <Button onClick={confirmStatus} disabled={!statusComment.trim()}>Save status</Button>
        </Group>
      </Modal>
    </>
  );

  if (isMobile) {
    return (
      <>
        <Box p="xs">
          {batches.map((batch) => (
            <MobileCardView key={batch.batch_no} batch={batch} />
          ))}
        </Box>
        {logsModal}
      </>
    );
  }

  /* ===========================
     DESKTOP TABLE VIEW
  ============================ */
  return (
    <Box style={{ overflow: "auto", maxHeight: "calc(100vh - 200px)" }}>
      {logsModal}
      <Table striped highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Batch No</Table.Th>
            <Table.Th>Start Date</Table.Th>
            <Table.Th>Course</Table.Th>
            <Table.Th>Trainer</Table.Th>
            <Table.Th>Sessions</Table.Th>
            <Table.Th>Admin</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th>Meeting</Table.Th>
            <Table.Th>Resources</Table.Th>
            <Table.Th>Actions</Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.Tbody>
          {batches.map((batch) => (
            <Table.Tr key={batch.batch_no}>
              <Table.Td>
                <Button size="xs" onClick={() => onBatchClick(batch)}>
                  {batch.batch_no}
                </Button>
              </Table.Td>

              <Table.Td>
                {batch.startDate
                  ? new Date(batch.startDate).toLocaleDateString("en-GB")
                  : "N/A"}
              </Table.Td>

              <Table.Td>{batch.courseName || "N/A"}</Table.Td>
              <Table.Td>{batch.trainerName || "N/A"}</Table.Td>

              <Table.Td>
                {editingSessionId === batch.batch_no ? (
                  <Group gap="xs">
                    <input
                      type="number"
                      value={sessionInputValue}
                      onChange={(e) =>
                        onSessionValueChange(parseInt(e.target.value))
                      }
                    />
                    <ActionIcon
                      color="green"
                      onClick={() => onSessionSave(batch.batch_no)}
                    >
                      <IconCheck size={16} />
                    </ActionIcon>
                    <ActionIcon color="gray" onClick={onSessionCancel}>
                      <IconX size={16} />
                    </ActionIcon>
                  </Group>
                ) : (
                  <Group gap="xs">
                    <Text>{batch.numSessions || 0}</Text>
                    <ActionIcon
                      variant="light"
                      onClick={() =>
                        onSessionEdit(batch.batch_no, batch.numSessions ?? 0)
                      }
                    >
                      <Pencil size={16} />
                    </ActionIcon>
                  </Group>
                )}
              </Table.Td>

              <Table.Td>{batch.admin || "N/A"}</Table.Td>

              <Table.Td>
                <Tooltip
                  label={batch.statusComment}
                  disabled={!batch.statusComment || !STATUSES_REQUIRING_COMMENT.includes(batch.batchStatus)}
                  multiline
                  maw={260}
                  withArrow
                >
                  <div style={{ display: "inline-block" }}>
                <select
                  value={batch.batchStatus}
                  onChange={(e) => handleStatusSelect(batch, e.target.value)}
                  style={{
                    padding: compact ? "4px" : "5px",
                    fontSize: compact ? "10px" : "11px",
                    borderRadius: "5px",
                    width: compact ? "110px" : "130px",
                    textAlign: "center",
                    backgroundColor: getStatusColor(batch.batchStatus),
                    color: "white",
                    fontWeight: "bold",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                  }}
                >
                  <option value="Completed">Completed</option>
                  <option value="Hold">Hold</option>
                  <option value="On-going">On-going</option>
                  <option value="Not Started">Not Started</option>
                  <option value="Absconded">Absconded</option>
                  <option value="Discarded">Discarded</option>
                </select>
                  </div>
                </Tooltip>
              </Table.Td>

              <Table.Td>
                <MeetingStatusBadge batch={batch} />
              </Table.Td>

              <Table.Td>
                <AdminResourceActions
                  batchNo={batch.batch_no}
                  onUpload={() => onUploadResource(batch.batch_no)}
                  onView={() => onViewResource(batch.batch_no)}
                />
              </Table.Td>

              {/*  ACTIONS */}
              <Table.Td>
                <Group gap="xs">
                  {/* View Journey */}
                  <ActionIcon
                    variant="light"
                    color="blue"
                    title="View Journey"
                    onClick={() =>
                      navigate(`/batches/${batch.batch_no}/journey`)
                    }
                  >
                    <IconTimeline size={16} />
                  </ActionIcon>

                  {/* View Attended Hours Logs */}
                  <ActionIcon
                    variant="light"
                    color="grape"
                    title="View Attended Hours Logs"
                    onClick={() => setLogsBatchNo(batch.batch_no)}
                  >
                    <IconHistory size={16} />
                  </ActionIcon>

                  {/* Delete */}
                  <ActionIcon
                    color="red"
                    variant="light"
                    onClick={() => onDeleteClick(batch)}
                  >
                    <IconTrash size={16} />
                  </ActionIcon>
                </Group>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
};
